import { writable } from 'svelte/store';

export const theme = writable('light');

// --- Initialize when app loads ---
export function initTheme() {
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    const mode = saved || (prefersDark ? 'dark' : 'light');
    applyTheme(mode);
    theme.set(mode);
}
//$: console.log("Theme store reactive:", theme);
//$: console.log('localStorage theme:', localStorage.getItem('theme'));
// --- Apply theme globally ---
function applyTheme(mode) {
    const root = document.documentElement;
    if (mode === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    localStorage.setItem('theme', mode);
}

// --- Toggle ---
export function toggleTheme() {
    theme.update((t) => {
        const next = t === 'dark' ? 'light' : 'dark';
        applyTheme(next);
        return next;
    });
}
